/*
  Fabriq 2026-10-10 : la barre de chargement du haut ne s'allume plus pour les appels réseau
  de fond (applis, mesures de Shopify, panier vérifié au chargement), seulement dans les
  secondes qui suivent un geste du visiteur (clic, touche, envoi, changement de choix, retour).

  Le thème l'allume sur chaque fetch de la page : xo-webcomponents remplace window.fetch et
  appelle la méthode statique run() de <xo-turbo-progress-bar>. On filtre run() ; complete()
  ne fait rien si run() n'a pas démarré la barre.
*/
(function () {
  var dernierGeste = 0;
  var FENETRE = 2500; // millisecondes après un geste

  function noter() { dernierGeste = Date.now(); }
  ['pointerdown', 'keydown', 'submit', 'change'].forEach(function (type) {
    document.addEventListener(type, noter, true);
  });
  window.addEventListener('popstate', noter);

  if (!window.customElements) return;
  customElements.whenDefined('xo-turbo-progress-bar').then(function () {
    var Barre = customElements.get('xo-turbo-progress-bar');
    if (!Barre || typeof Barre.run !== 'function' || Barre.tfFiltre) return;
    var lancer = Barre.run;
    Barre.run = function () {
      if (Date.now() - dernierGeste > FENETRE) return;
      return lancer.apply(this, arguments);
    };
    Barre.tfFiltre = true;
  });
})();
